<template lang="pug">
    v-container(fill-height grid-list-lg fluid)
        div(style="top:0; right:0; position:absolute; z-index: 10001;").ma-5
            a(@click="goToPolicyDoc").grey--text Privacy Policy
        v-layout(align-center justify-start)
            v-flex(xs12 sm6 md5 lg4 xl3 offset-lg1)
                v-card(style="z-index: 10000; background-color: transparent" flat)
                    v-overlay(absolute :value="loading")
                        v-progress-circular(indeterminate size="64")
                    template(v-if="true")
                        v-card-text
                            .layout.column.align-center.pb-4.pt-5
                                v-img(:src="appLogoColor" contain max-height=280)
                        v-card-actions.pb-5.mb-5
                            v-btn(color="#db3236" block dark rounded large @click="onClickGoogleLogin")
                                v-icon(left) mdi-google-plus
                                span(v-if="$vuetify.breakpoint.mdAndUp") Login With Google
                                span(v-else) Login
                background-animated(:urls="urls" :delay="delay" v-if="true")
                .layout.column.align-center.pt-5
                        v-card(style="z-index: 20000; background-color: transparent" flat)
                            v-card-text.text-sm-center {{footer}}
</template>

<script>
import general from "../../mixins/general";
import rules from "../../mixins/rules";
import { call, get } from "vuex-pathify";
import BackgroundAnimated from "../../components/commons/BackgroundAnimated";

export default {
  name: "SignIn",
  components: { BackgroundAnimated },
  mixins: [general, rules],
  data() {
    return {
      email: "admin.fmg@gmail.com",
      password: "password",
      urls: [],
      delay: 6
    };
  },
  computed: {
    loading: get("auth/loading"),
    emailRules: {
      get() {
        return [
          v => !!v || "Email is required.",
          v =>
            !v ||
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) ||
            "Must be a valid email address."
        ];
      }
    },
    footer() {
      return `Copyright © ${new Date().getFullYear()} ISD Productions. all rights reserved.`;
    },
    passwordRules: {
      get() {
        return [v => !!v || "Password is required."];
      }
    }
  },
  methods: {
    login: call("auth/login"),
    loginGoogle: call("auth/loginGoogle"),
    fetchUser: call("auth/fetchUser"),
    async onSubmit() {
      if (this.$refs.form.validate()) {
        const data = await this.login({
          email: this.email,
          password: this.password
        }).catch(({ status }) => {
          if (status === 401)
            this.$toasted.error("Account not found", { icon: "mood_bad" });
          else this.$toasted.error("Can't login", { icon: "error" });
        });
        if (!data) return;
        await this.$store.set("remember/token", data.access_token);
        this.fetchUser().then(() => {
          this.$router.push({ name: "home" });
          this.$toasted.success("Logged in.", { icon: "check" });
        });
      }
    },
    onClickGoogleLogin() {
      this.$gAuth
        .getAuthCode()
        .then(async code => {
          // console.log("google ok:", code);
          //on success
          // return this.$http.post('http://your-backend-server.com/auth/google', { code: authCode, redirect_uri: 'postmessage' })
          // return this.axios.post(`auth/google`, {code})
          const data = await this.loginGoogle({ code }).catch(({ status }) => {
            if (status === 401)
              this.$toasted.error("Account not found", { icon: "mood_bad" });
            else this.$toasted.error("Can't login", { icon: "error" });
          });
          if (!data) return;
          await this.$store.set("remember/token", data.access_token);
          this.fetchUser().then(() => {
            this.$router.push({ name: "home" });
            this.$toasted.success("Logged in.", { icon: "check" });
          });
        })
        .catch(error => {
          //on fail do something
          console.log("google failed:", error);
        });

      // this.$gAuth.signIn()
      //     .then(user => {
      //         // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
      //         console.log('google ok:', user);
      //         // console.log('google ok:', this.$gAuth);
      //         // console.log('isAuthorized', this.$gAuth.isAuthorized)
      //     })
      //     .catch(error  => {
      //         // On fail do something
      //         console.log('google failed:', error);
      //     })
    },
    onClickLogout() {
      this.$gAuth
        .signOut()
        .then(data => {
          console.log("google ok:", data);
        })
        .catch(error => {
          // On fail do something
          console.log("google failed:", error);
        });
    },
    goToPolicyDoc() {
      this.$router.push({ name: "policy" });
    }
  },
  mounted() {
    if (this.$store.get("remember/token")) {
      this.fetchUser().then(() => {
        this.$nextTick(() => {
          this.$router.push({ name: "home" });
        });
      });
    }
    this.axios
      .get(`bg`)
      .then(res => {
        this.urls = res.data.urls;
        this.delay = res.data.delay;
      })
      .catch(() => {
        this.delay = 6;
        this.urls = [
          "/images/01.jpg",
          "/images/02.jpg",
          "/images/03.jpg",
          "/images/04.jpg",
          "/images/05.jpg"
        ];
      });
  }
};
</script>
